import { Component, Input, OnInit, OnDestroy, OnChanges, SimpleChanges } from '@angular/core';
import { Router, NavigationStart, NavigationEnd, NavigationError, Event, ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs';
// import { TranslateService } from '@ngx-translate/core';
import { InfomodalComponent } from 'src/app/main/shared/infomodal/infomodal.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';


import { FloodForecastUtilsService } from '../../flood-forecast-shared/floodForecastUtils.service';
import { BottombarMenusComponent } from './../bottombar-menus.component';

@Component({
  selector: 'app-layer-control',
  templateUrl: './layer-control.component.html',
  styleUrls: ['./layer-control.component.scss']
})
export class LayerControlComponent implements OnInit, OnChanges, OnDestroy {

  @Input() map: any;
  @Input() layersList: any;

  groupList: any;
  urlParams: any;
  activeLayer: any;
  selectedOption: string;
  htmlLegendObjects: any = [];
  curerentActiveLayerName: any;
  modalRef : any;
  navigationSubscription: Subscription;

  constructor(private bottomBarMenusComponent: BottombarMenusComponent, private route: ActivatedRoute,
    // public translate: TranslateService,
    private modalService: NgbModal,
    private router: Router, private ffUtilsService: FloodForecastUtilsService) {
      // translate.setDefaultLang('en');
    this.navigationSubscription = this.router.events.subscribe((event: Event) => {
      if (event instanceof NavigationStart) {
        // Show loading indicator
      }
      if (event instanceof NavigationEnd) {
        this.urlParams = this.ffUtilsService.checkUrlParams(this.route.snapshot.params);
      }
      if (event instanceof NavigationError) {
        console.log(event.error); // Hide loading indicator  // Present error to user
      }
    });
    ffUtilsService.getFloodForecastSelectedSideBarApplication().subscribe(value => {
      this.selectedOption = value;
    });
  }

  ngOnInit() {
    this.urlParams = this.ffUtilsService.checkUrlParams(this.route.snapshot.params);
    this.map.on('click', (e) => {
      this.bottomBarMenusComponent.bottomBarOpen = true;
    });
  }

  ngOnChanges(changes: SimpleChanges) {
    // console.log(changes.layersList);
  }

  accordianOnClick(event) {
    const target = event.target || event.srcElement || event.currentTarget;
    /* Toggle between adding and removing the "active" class,
    to highlight the button that controls the panel */
    target.classList.toggle('active');

    /* Toggle between hiding and showing the active panel */
    const panel = target.nextElementSibling as HTMLElement;
    if (panel.style.display === 'block') {
      panel.style.display = 'none';
    } else {
      panel.style.display = 'block';
    }
  }

  showAndHideLayer(layer, base) {
    if (base) {
      for (const key in this.layersList.baseLayers) {
        if (this.layersList.baseLayers.hasOwnProperty(key)) {
          const value = this.layersList.baseLayers[key];
          if (this.map.hasLayer(value)) {
            this.map.removeLayer(value);
          }
          value.options.visible = false;
        }
      }
      this.map.addLayer(layer);
      layer.options.visible = true;
      return;
    }

    let idDeselect = false;
    for (const key in this.layersList.overlayLayers) {
      if (this.layersList.overlayLayers.hasOwnProperty(key)) {
        const overlay = this.layersList.overlayLayers[key];
        if (layer.options.groupType === 'radio' && overlay.options.group === layer.options.group) {
          this.map.removeLayer(overlay);
          overlay.options.visible = false;
        }
        if (layer.options.groupType === 'radio-deselect') {
          if ((layer.options.group == 'Rainfall Forecast' || layer.options.group == 'Rainfall Actual' || layer.options.group == 'catchment')
            && (overlay.options.group == 'Rainfall Forecast' || overlay.options.group == 'Rainfall Actual' || overlay.options.group == 'catchment')) {
            if (layer === overlay && overlay.options.visible === true) {
              idDeselect = true;
            }
            if (overlay.options.visible == true) {
              this.map.removeLayer(overlay);
            }
            overlay.options.visible = false;
          }
        }
      }
    }

    if (this.map.hasLayer(layer)) {
      this.map.removeLayer(layer);
      layer.options.visible = false;
    } else if (!idDeselect) {
      this.map.addLayer(layer);
      layer.options.visible = true;
      // check first if random heatMap from datePicker is on map or not if it is the first remove it
    }
  }

  changeSelectedOption(value: any) {
    if (this.selectedOption === value) {
      this.selectedOption = null;
    } else {
      this.selectedOption = value;
    }
    this.ffUtilsService.setFloodForecastSelectedSideBarApplication(this.selectedOption);
  }

  ngOnDestroy() {
    this.navigationSubscription.unsubscribe();
  }

  infoclick(value) {
    this.modalRef = this.modalService.open(InfomodalComponent,{ backdrop: 'static', keyboard: true, windowClass: 'backgroundTransparent  infocomponent'})
    this.modalRef.componentInstance.selected = value;
  }
}
